
export const compFields = [
  { key: 'propertyName', label: 'Property Name', type: 'text', for: ['sales', 'rent', 'prospecting'] },
  { key: 'distanceFromSubject', label: 'Miles', type: 'number', for: ['sales', 'rent', 'prospecting'] },
  { key: 'propertyTotalUnits', label: '# Units', type: 'number', for: ['sales', 'rent', 'prospecting'] },
  { key: 'totalBeds', label: '# Beds', type: 'number', for: ['rent', 'sales'] },
  { key: 'sizeSquareFeet', label: 'TRSF', type: 'number', for: ['sales', 'rent', 'prospecting'] },
  { key: 'yearBuilt', label: 'Built | Reno', for: ['sales', 'rent', 'prospecting'] },
  { key: 'occupancy', label: 'Occupancy', type: 'percent', for: ['sales', 'rent', 'prospecting'] },
  { key: 'averageSizeSquareFeetPerUnit', label: 'SF/Unit', type: 'number', for: ['rent', 'prospecting'] },
  { key: 'mostRecentSaleDate', label: 'Sale Date', type: 'date', for: ['sales'] },
  // { key: 'datePutOnMarket', label: 'Date On Market', type: 'date', for: ['prospecting'] },
  // { key: 'datePutOffMarket', label: 'Date Off Market', type: 'date', for: ['prospecting'] },
  { key: 'mostRecentSalePrice', label: 'Sale Price', type: 'currency', for: ['sales'] },
  { key: 'propertyPricePerUnit', label: '$/Unit', type: 'currency', for: ['sales'] },
  { key: 'pricePerSquareFeet', label: '$/SF', type: 'currency', for: ['sales'] },
  { key: 'propertyPricePerBed', label: '$/Bed', type: 'currency', for: ['sales'] },
  { key: 'propertyCapRate', label: 'Cap Rate', type: 'percent', for: ['sales'] },
  { key: 'averageRentPerSquareFeet', label: 'MR/SF', type: 'currency', for: ['rent'] },
  { key: 'averageRentPerUnit', label: 'MR/Unit', type: 'currency', for: ['rent'] },
  { key: 'averageRentPerBed', label: 'MR/Bed', type: 'currency', for: ['rent'] },
  { key: 'salesforceAccountName', label: 'Owner', type: 'text', for: ['prospecting'] },
  { key: 'salesforceContactName', label: 'Contact', type: 'text', for: ['prospecting'] },

  // { key: 'listingsHistoryOnMarket', label: 'On Market', type: 'text', for: ['listing'] },
  // { key: 'datePutOnMarket', label: 'On | Off Market Date', type: 'text', for: ['listing'] },
  // { key: 'datePutOffMarket', label: 'Off Market Date', type: 'date', for: ['listing'] },
  // { key: 'Updatedval', label: 'Updated', type: 'text', for: ['rent'] },
  // { key: 'BCM', label: 'Source', type: 'text', for: ['rent'] }

]

export default {
  compFields

}
